'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _lodashMapvalues = require('lodash.mapvalues');

var _lodashMapvalues2 = _interopRequireDefault(_lodashMapvalues);

var _constants = require('./constants');

var searchParams = (0, _lodashMapvalues2['default'])(_constants.SEARCH_PARAMS, function (value, key) {
  return ':' + key;
});

var companyid = searchParams.companyid;
var classification = searchParams.classification;
var subclassification = searchParams.subclassification;
var where = searchParams.where;
var graduatesearch = searchParams.graduatesearch;
var worktype = searchParams.worktype;
exports['default'] = ['/jobs/at-' + companyid, '/jobs-in-' + classification + '/' + subclassification + '/in-' + where + '/' + graduatesearch + '/' + worktype, '/jobs-in-' + classification + '/' + subclassification + '/in-' + where + '/' + graduatesearch, '/jobs-in-' + classification + '/' + subclassification + '/in-' + where + '/' + worktype, '/jobs-in-' + classification + '/' + subclassification + '/in-' + where, '/jobs-in-' + classification + '/' + subclassification + '/' + graduatesearch + '/' + worktype, '/jobs-in-' + classification + '/' + subclassification + '/' + graduatesearch, '/jobs-in-' + classification + '/' + subclassification + '/' + worktype, '/jobs-in-' + classification + '/' + subclassification, '/jobs-in-' + classification + '/in-' + where + '/' + graduatesearch + '/' + worktype, '/jobs-in-' + classification + '/in-' + where + '/' + graduatesearch, '/jobs-in-' + classification + '/in-' + where + '/' + worktype, '/jobs-in-' + classification + '/in-' + where, '/jobs-in-' + classification + '/' + graduatesearch + '/' + worktype, '/jobs-in-' + classification + '/' + graduatesearch, '/jobs-in-' + classification + '/' + worktype, '/jobs-in-' + classification, '/jobs/in-' + where + '/' + graduatesearch + '/' + worktype, '/jobs/in-' + where + '/' + graduatesearch, '/jobs/in-' + where + '/' + worktype, '/jobs/in-' + where, '/jobs/' + graduatesearch + '/' + worktype, '/jobs/' + graduatesearch, '/jobs/' + worktype, '/jobs'];
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-jobs-seo/build/clean-urls.js
 ** module id = 520
 ** module chunks = 0
 **/